import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import SecondaryButton from "../../../components/SecondaryButton";
import PageHeader from "../../../components/PageHeader";
import InputField from "../../../components/InputField";
import axiosInstance from "../../../utils/axiosInstance";
import { fetchDoctorProfile, registerUser, updateDoctorDetails, updateUserDetais } from "../../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import TextAreaField from "../../../components/TextAreaField";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";
import { updateDoctorData } from "../../../store/appSlice";
import toast from "react-hot-toast";

export default function EditConsultationType() {
  pageTitle("Edit Consultation Type");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData)?.id;
  const [clinicDetails, setClinicDetails] = useState("");
  const [clinicAddress, setClinicAddress] = useState("");
  //   const [clinicLocation, setClinicLocation] = useState("");
  const [clinicName, setClinicName] = useState(false);
  const [onlineConsulation, setOnlineConsultation] = useState(0);
  const [clinicConsultation, setCliniConsultation] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [doctorDetail, setDoctorDetail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorId })
      .then((res) => {
        setDoctorDetail(res?.data?.data);
        setOnlineConsultation(res?.data?.data?.online_consultation || 0);
        setCliniConsultation(res?.data?.data?.clinic_consultation || 0);
        setClinicName(res?.data?.data?.clinic_name || "");
        setClinicAddress(res?.data?.data?.clinic_address || "");
        // setClinicLocation(res?.data?.data?.clinic_location || "");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    if (clinicConsultation == 1 && (clinicName === "" || clinicAddress == "")) {
      toast.error("Please provide clinic information");
      return;
    }
    const payload = {
      doctor_id: doctorId,
      online_consultation: onlineConsulation,
      clinic_consultation: clinicConsultation,
      clinic_name: clinicName,
      clinic_address: clinicAddress,
      //   clinic_location: clinicLocation,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate(-1);
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  const handleOnlineConsultationChange = (e) => {
    setOnlineConsultation(e.target.checked ? 1 : 0);
  };

  const handleClinicConsultationChange = (e) => {
    setCliniConsultation(e.target.checked ? 1 : 0);
  };

  return (
    <Wrapper>
      <Section topMd={0} topLg={0} topXl={0} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 align-items-center gap-1 justify-content-center">
          <div className="col-12 col-lg-6 g-2">
            <CommonMobileHeader canBack title="Consultation Type" />
            <strong className="my-0 text-dark">Choose consultation Type</strong>
            <span className="fs-md text-grey1 d-block my-0 ">You can change this later</span>
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="d-flex gap-2">
                <input type="checkbox" checked={onlineConsulation === 1} onChange={handleOnlineConsultationChange} />
                <strong className="text-grey2 fs-normal">Online</strong>
              </div>
              <div className="d-flex gap-2">
                <input type="checkbox" checked={clinicConsultation === 1} onChange={handleClinicConsultationChange} />
                <strong className="text-grey2 fs-normal">At Clinic</strong>
              </div>
            </div>
            {clinicConsultation === 1 && (
              <>
                <strong className="my-0 text-dark">Add Clinic Details</strong>
                <span className="fs-md text-grey1 d-block my-0 mb-3">Where you will be consulting patients</span>
                <InputField label="Clinic Name" placeholder="Enter text..." inputType={"text"} value={clinicName} onChange={(e) => setClinicName(e.target.value)} />
                <TextAreaField rows={3} label="Clinic Address" placeholder="Enter here..." inputType={"text"} value={clinicAddress} onChange={(e) => setClinicAddress(e.target.value)} />
                {/* <InputField label="Clinic Location" placeholder="Enter text..." inputType={"text"} value={clinicLocation} onChange={(e) => setClinicLocation(e.target.value)} /> */}
              </>
            )}
            <SecondaryButton title={"Continue"} className={"mt-3"} onClick={handleSubmitClick} loading={submitting} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
